import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';

const NotesDialog = ({
  open,
  onOpenChange,
  orderNotes,
  setOrderNotes
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader><DialogTitle>Order Notes</DialogTitle></DialogHeader>
        <Textarea 
          placeholder="Special instructions..." 
          value={orderNotes} 
          onChange={(e) => setOrderNotes(e.target.value)} 
          rows={4} 
          data-testid="order-notes-input"
        />
        <Button className="w-full" onClick={() => onOpenChange(false)}>Save</Button>
      </DialogContent>
    </Dialog>
  );
};

export default NotesDialog;
